export enum MainOnboardingSteps {
  Start = 'Start',
  Taps = 'Taps',
  CrystalCounter = 'CrystalCounter',
  OpenImprovements = 'OpenImprovements',
  PauseForRenderImprovementsMap = 'PauseForRenderImprovementsMap',
  BuyImprovement = 'BuyImprovement',
  MinePerHour = 'MinePerHour',
  LeaderboardLocked = 'LeaderboardLocked',
  ContinueTap = 'ContinueTap',
  TapsMining = 'TapsMining',
  OpenTasks = 'OpenTasks',
  WaitBeforeTasksBackEnabled = 'WaitBeforeTasksBackEnabled',
  BackToMainFromTasks = 'BackToMainFromTasks',
  Finish = 'Finish',
}

export enum MainOnboardingStartSteps {
  StartWithGift = 'StartWithGift',
  StartCommon = 'StartCommon',
}

export enum MainOnboardingFinishSteps {
  FinishWithViewGift = 'FinishWithViewGift',
  FinishWithoutGift = 'FinishWithoutGift',
}

export const MAIN_ONBOARDING_SCRIPT: MainOnboardingSteps[] = [
  MainOnboardingSteps.Start,
  MainOnboardingSteps.Taps,
  MainOnboardingSteps.CrystalCounter,
  MainOnboardingSteps.OpenImprovements,
  MainOnboardingSteps.PauseForRenderImprovementsMap,
  MainOnboardingSteps.BuyImprovement,
  MainOnboardingSteps.MinePerHour,
  MainOnboardingSteps.LeaderboardLocked,
  MainOnboardingSteps.ContinueTap,
  MainOnboardingSteps.TapsMining,
  MainOnboardingSteps.OpenTasks,
  MainOnboardingSteps.WaitBeforeTasksBackEnabled,
  MainOnboardingSteps.BackToMainFromTasks,
  MainOnboardingSteps.Finish,
];

export enum DailyGameOnboardingSteps {
  SelectSymbol = 'SelectSymbol',
  CheckTip = 'CheckTip',
  NextGame = 'NextGame',
  Pause1 = 'Pause1',
  Pause2 = 'Pause2',
}

export const DAILY_GAME_ONBOARDING_SCRIPT: DailyGameOnboardingSteps[] = [
  DailyGameOnboardingSteps.SelectSymbol,
  DailyGameOnboardingSteps.Pause1,
  DailyGameOnboardingSteps.CheckTip,
  DailyGameOnboardingSteps.Pause2,
  DailyGameOnboardingSteps.NextGame,
];

export enum TooltipId {
  KotletkaMessage = 'KotletkaMessage',
  OpenDailyGame = 'OpenDailyGame',
  OpenSettings = 'OpenSettings',
  SoonRecalculation = 'SoonRecalculation',
  TimerForRecalculation = 'TimerForRecalculation',
}
